import React from 'react';

import PropTypes from 'prop-types';
import FaClose from 'react-icons/lib/fa/close';

import Button from '../Button/Button';

const propTypes = {
    className: PropTypes.string,
    onDismiss: PropTypes.func,
    type: PropTypes.oneOf([
        'info',
    ]).isRequired,
};
const defaultProps = {
    className: '',
    onDismiss: undefined,
};

import styles from './Notification.scss';

function Notification(props) {
    const {
        children,
        className,
        onDismiss,
        type,
    } = props;

    return (
        <div className={`${styles.notification} ${styles[type]} ${className}`}>
            <div className={styles.content}>
                {children}
            </div>

            {onDismiss && (
                <Button
                    className={styles.dismissButton}
                    onClick={onDismiss}
                    unstyled
                >
                    <FaClose />
                </Button>
            )}
        </div>
    );
}

Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;

export default Notification;
